import { ErrorBlock, ErrorBlockErr } from 'components/ErrorBlock'
import React, { useState } from 'react'

export const useFormErr = (): [React.Dispatch<React.SetStateAction<ErrorBlockErr>>, React.FC] => {
	const [err, setErr] = useState<ErrorBlockErr>(null)

	const Err = () => (err ? <ErrorBlock error={err} display='inline' hideCta /> : null)

	return [setErr, Err]
}
